import { Routes } from '@angular/router';
import {
    AddbannerComponent,
    AddblogComponent,
    AddcolleagueComponent,
    BannersComponent,
    BlogComponent,
    ColleaguesComponent,
    HomeConfigComponent,
    SigninComponent,
    SiteConfigComponent,
    UpdatebannerComponent,
    UpdateblogComponent,
    UpdateHomeConfigComponent
} from '@prekog/common-ui';
import { AddconsultationhourComponent } from './doctors/addconsultationhour/addconsultationhour.component';
import { AdddoctorComponent } from './doctors/adddoctor/adddoctor.component';
import { AddjobtitleComponent } from './doctors/addjobtitle/addjobtitle.component';
import { DoctorsComponent } from './doctors/doctors.component';
import { UpdatedoctorComponent } from './doctors/updatedoctor/updatedoctor.component';
import { HomeComponent } from './home/home.component';
import { AddexaminationComponent } from './pricelist/addexamination/addexamination.component';
import { PricelistComponent } from './pricelist/pricelist.component';
import { AddspecialityComponent } from './specialities/addspeciality/addspeciality.component';
import { SpecialitiesComponent } from './specialities/specialities.component';
import { UpdatespecialityComponent } from './specialities/updatespeciality/updatespeciality.component';
import { SpecialityPriceListComponent } from './specialitypricelist/specialitypricelist.component';
import { AddspecialitytypeComponent } from './specialitytype/addspecialitytype/addspecialitytype.component';
import { UpdatespecialitytypeComponent } from './specialitytype/updatespecialitytype/updatespecialitytype.component';

export const routes: Routes = [
    { path: '', component: SigninComponent },
    { path: 'home', component: HomeComponent },
    { path: 'banners', component: BannersComponent },
    { path: 'banners/:id', component: UpdatebannerComponent },
    { path: 'addbanner', component: AddbannerComponent },
    { path: 'specialitypricelist', component: SpecialityPriceListComponent },
    { path: 'pricelist/:routerLink', component: PricelistComponent },
    { path: 'addexamination/:routerLink', component: AddexaminationComponent },
    { path: 'doctors', component: DoctorsComponent },
    { path: 'doctor/:routerLink', component: UpdatedoctorComponent },
    { path: 'addconsultationhour/:routerLink', component: AddconsultationhourComponent },
    { path: 'adddoctor', component: AdddoctorComponent },
    { path: 'addjobtitle/:id', component: AddjobtitleComponent },
    { path: 'specialities', component: SpecialitiesComponent },
    { path: 'addspeciality', component: AddspecialityComponent },
    { path: 'updatespeciality/:id', component: UpdatespecialityComponent },
    { path: 'siteconfig', component: SiteConfigComponent },
    { path: 'colleagues', component: ColleaguesComponent },
    { path: 'addcolleague', component: AddcolleagueComponent },
    { path: 'blog', component: BlogComponent },
    { path: 'blog/:routerLink', component: UpdateblogComponent },
    { path: 'homeconfig', component: HomeConfigComponent },
    { path: 'homeconfig/:component', component: UpdateHomeConfigComponent },
    { path: 'addblog', component: AddblogComponent },
    { path: 'addspecialitytype', component: AddspecialitytypeComponent },
    { path: 'updatespecialitytype/:id', component: UpdatespecialitytypeComponent }
];
